import React from 'react'
import {
  BETQL,
  BETQL_BLUE,
  THEME_BETQL_GREEN,
  THEME_BETQL_BLUE,
  THEME_BASE_WHITE,
} from 'theme/constants'

import { BETQL_PROJECT_ROUTE } from 'routes/constants'

import BetQLLogo from 'images/logos/betql.svg'

// BetQL Images
import BetQLHeroLeft from 'images/projects/betql/betql-hero-left.avif'
import BetQLHeroRight from 'images/projects/betql/betql-hero-right.avif'
import BetQLFullWidthOne from 'images/projects/betql/betql-full-width-1.avif'
import BetQLFullWidthOneMobile from 'images/projects/betql/betql-full-width-1-mobile.webp'
import BetQLLeftOne from 'images/projects/betql/betql-image-left-1.webp'
import BetQLLeftOneMobile from 'images/projects/betql/betql-image-left-1-mobile.webp'
import BetQLRightOne from 'images/projects/betql/betql-image-right-1.avif'
import BetQLRightOneMobile from 'images/projects/betql/betql-image-right-1-mobile.webp'

const data = {
  id: BETQL,
  name: 'BetQL',
  route: BETQL_PROJECT_ROUTE,
  general: {
    logo: <BetQLLogo />,
    tagline: 'Make informed bets using BetQL.',
  },
  theme: {
    primary: BETQL_BLUE,
  },
  colors: {
    primary: BETQL_BLUE,
  },
  hero: {
    theme: THEME_BETQL_GREEN,
    slides: [
      {
        text: 'Make informed bets using <b>BetQL.</b>',
        images: [
          { key: 'left', image: BetQLHeroLeft },
          { key: 'right', image: BetQLHeroRight },
        ],
      },
    ],
  },
  overview: {
    client: 'BetQL',
    theme: THEME_BASE_WHITE,
    sector: 'Sports',
    year: '2020 - 2021',
    paragraphs: [
      'BetQL helps casual to hardcore bettors make more informed bets using data and analytics.',
      'The product analyzes unique bets across major sports/leagues to find profitable betting opportunities. Then packages them in a way that is easy to digest for the common fan.',
      'As leaders in the space, BetQL needed our expertise in levelling up their visual identity to be on par with the quality and sophistication of the product and metrics provided. As part of an effort to appeal more to their casual better for mass market expansion, the shift in visual identity would need to feel approachable and trustworthy with a clean sportiness.',
    ],
  },
  solution: {
    theme: THEME_BETQL_BLUE,
    title: 'Moodboards',
    paragraphs: [
      'We started with exploratory moodboards that represent possible worlds for the product to live within. These boards help us define what the brand will convey to users directionally.',
    ],
    image: {
      source: BetQLFullWidthOne,
      desktop: BetQLFullWidthOne,
      mobile: BetQLFullWidthOneMobile,
      alt: 'Exploratory moodboards that represent possible direction for the brand',
    },
  },
  twoTextImageColumns: [
    {
      theme: THEME_BASE_WHITE,
      title: 'Brand Guidelines',
      paragraphs: [
        'After the core brand elements were confirmed, our team expanded on usage rules, guidelines, and sample applications for the entire visual identity. Our brand guidelines document is meant to be an ever-evolving tool that provides a north star to the product design team, marketing team, and new business efforts.',
      ],
      image: {
        source: BetQLRightOne,
        desktop: BetQLRightOne,
        mobile: BetQLRightOneMobile,
        alt: 'Brand book for new BetQL branding',
      },
    },
    {
      theme: THEME_BETQL_GREEN,
      title: 'Application',
      paragraphs: [
        'We applied updated brand elements into the core user journey for mobile and web UI as well as the non-product touchpoints that users interact with like social banners and email templates.',
      ],
      image: {
        source: BetQLLeftOne,
        desktop: BetQLLeftOne,
        mobile: BetQLLeftOneMobile,
        alt: 'ios Mobile application showing the new BetQL branding + UI',
      },
      isImageOnLeft: true,
    },
  ],
}

export default data
